const payment = {
  'Total payment amount exceeds payment_order amount': 'El monto del pago excede al monto del costo',
}

export default payment
